export default __webpack_public_path__ + "static/media/pitikInfo.a806824e.png";